module.exports = __webpack_public_path__ + "img/image-section4.d0ccebb3.png";